
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class BodyParagraph extends Vue {  
  @Prop() content!: string;  
}
